import { getPatternStyles, patternFns } from './runtime.js';
import { memo } from '../helpers.js';
import { css } from '../css/index.js';

const spacerConfig = { transform(props, { map, isCssUnit, isCssVar }) {
  const { size, ...rest } = props;
  return {
    alignSelf: "stretch",
    justifySelf: "stretch",
    flex: map(size, (v) => {
      if (v == null) return "1";
      const val = isCssUnit(v) || isCssVar(v) ? v : `token(spacing.${v}, ${v})`;
      return `0 0 ${val}`;
    }),
    ...rest
  };
} }

export function spacerRaw(styles) {
  const s = getPatternStyles(spacerConfig, styles || {})
  return spacerConfig.transform(s, patternFns)
}

export const spacer = /* @__PURE__ */ Object.assign(/* @__PURE__ */ memo(function spacer(styles = {}) {
  return css(spacerRaw(styles))
}), { raw: spacerRaw, propKeys: ["size"] })